// Company: Ajinsoft
// Author: Uilan Coqueiro
// Date: 2023-03-30

export const themes = [
    {
        id: 'theme-default',
        name: 'Default'
    },
    {
        id: 'theme-brand',
        name: 'Brand'
    },
    {
        id: 'theme-blue',
        name: 'Blue'
    },
    {
        id: 'theme-teal',
        name: 'Teal'
    },
    {
        id: 'theme-rose',
        name: 'Rose'
    },
    {
        id: 'theme-purple',
        name: 'Purple'
    },
    {
        id: 'theme-amber',
        name: 'Amber'
    },
    {
        id: 'theme-red',
        name: 'Red'
    },
    {
        id: 'theme-green',
        name: 'Green'
    },
    {
        id: 'theme-task',
        name: 'Task'
    },
		{
			id: 'theme-finance',
			name: 'Purple'
	}
]
